import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="var(--sds--ursa-icons--inner-shape-color, transparent)"
            d="M10 6.982a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M10.7 10a.7.7 0 1 0-1.4 0v2.96a.7.7 0 1 0 1.4 0z"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0m6.25-2.268a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0M10 9.3a.7.7 0 0 1 .7.7v2.96a.7.7 0 1 1-1.4 0V10a.7.7 0 0 1 .7-.7"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
